import Api from './index'

const urlBase = '/quotations/'

export function createQuotation(params) {
  return Api().post(urlBase, params)
}

export function updateQuotation(token, params) {
  return Api().put(`${urlBase}/${token}`, params)
}